<div class="card">
  <app-header
    [titulo]="isEditMode ? 'Editar Processo' : 'Novo Processo'"
    [descricao]="isEditMode ? 'Atualize os dados gerais do processo' : 'Dê um nome ao processo; depois você vai configurar as etapas do fluxo'">
  </app-header>

  <div class="info-message mb-4" *ngIf="!isEditMode" role="note">
    <i class="pi pi-info-circle"></i>
    <span>Um processo reúne as etapas de uma integração. Depois de salvar, você poderá adicionar a importação, o processamento e o destino dos dados.</span>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()">
    <section class="form-panel">
      <h3>1. Identifique o processo</h3>
      <p>Dê um nome fácil de reconhecer e explique quais dados serão integrados.</p>
      <div class="p-fluid grid">
      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome do Processo *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres).
        </small>
        <small class="text-500">Ex.: Sincronizar pedidos diariamente.</small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <textarea
            pInputTextarea
            id="descricao"
            formControlName="descricao"
            rows="4"
            [class.ng-invalid]="campoInvalido('descricao')"
            [class.ng-dirty]="campoInvalido('descricao')"
          ></textarea>
          <label for="descricao">Descrição *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('descricao')">
          Descrição é obrigatória.
        </small>
      </div>
      </div>
    </section>

    <section class="form-panel mt-4">
      <h3>2. Associe a um sistema</h3>
      <p>O sistema reúne os processos de uma mesma aplicação, como seu ERP ou loja virtual.</p>
      <div class="p-fluid grid">
      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-dropdown
            id="sistemaId"
            formControlName="sistemaId"
            [options]="sistemas"
            optionLabel="nome"
            optionValue="id"
            [filter]="sistemas.length > 8"
            filterBy="nome"
            appendTo="body"
            [style]="{'width':'100%'}"
            [class.ng-invalid]="campoInvalido('sistemaId')"
            [class.ng-dirty]="campoInvalido('sistemaId')"
          ></p-dropdown>
          <label for="sistemaId">Sistema *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('sistemaId')">
          Selecione o sistema do processo.
        </small>
        <small class="text-500">Escolha o sistema ao qual este processo pertence.</small>
      </div>

      <div class="col-12" *ngIf="!carregandoSistemas && sistemas.length === 0">
        <div class="info-message">
          <i class="pi pi-info-circle"></i>
          <span>
            Nenhum sistema cadastrado. Todo processo pertence a um sistema: cadastre o primeiro antes de criar o processo.
          </span>
          <p-button label="Cadastrar sistema" icon="pi pi-plus" severity="info" [outlined]="true" (onClick)="irParaSistemas()"></p-button>
        </div>
      </div>

      </div>
    </section>

    <!-- Botões de Ação -->
    <div class="flex justify-content-end gap-2 mt-4 pt-4 border-top-1 surface-border">
      <p-button
        label="Voltar"
        icon="pi pi-arrow-left"
        severity="secondary"
        (onClick)="voltar()"
        [disabled]="loading">
      </p-button>

      <p-button
        [label]="isEditMode ? 'Atualizar' : 'Salvar e Configurar'"
        icon="pi pi-check"
        severity="success"
        type="submit"
        [loading]="loading">
      </p-button>
    </div>
  </form>
</div>
